import Alert from "@storeblocks/alert";
import React from "react";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useTexts } from "Store/texts";

interface Props {
  product: ProductBackendName;
}

export const ChildHealthAlert: React.FC<Props> = ({ product }) => {
  const texts = useTexts();

  if (product !== ProductBackendName.CHILD_HEALTH) {
    return null;
  }

  return (
    <Alert
      title={texts.domain["childHealth.checkPrice.alert.title"]}
      description={texts.domain["childHealth.checkPrice.alert.description"]}
    />
  );
};
